module.exports = __webpack_public_path__ + "img/avatar2.2030b343.png";